<div *ngIf="message" [ngClass]="{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }">{{message.text}}</div>



// WEBPACK FOOTER //
// ./src/app/_directives/alert.component.html